import {Component, OnDestroy, OnInit, Input, ViewChild, AfterViewInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CreateProduct } from 'src/app/modules/product/components/edit-fund/create-product';
import { ParseDataService } from 'src/app/modules/product/services/parseData.service';
import { Product } from '../../models/product.model';
import { ValidateService } from 'src/app/modules/product/services/validate.service';
import { MasterDataProductService } from 'src/app/modules/product/services/master-data-product.service';
import { ProductService } from '../../product.service';
import { DataService } from '../../services/data.service';
import { forkJoin, of, Subscription } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { LocaleService } from '../../services/datepicker.service';
import { EventManager } from 'src/app/core';
import { ChangedObject } from 'src/app/shared/util/object-change.util';
  import { CheckChangeProductPopupComponent } from '../check-change-product-popup/check-change-product-popup.component';
import { DateUtil } from 'src/app/shared/util/date.util';
import { Constant } from 'src/app/core/constant';
import { FileUploader } from 'ng2-file-upload';
import { UploaderService } from 'src/app/shared/services/uploader.service';
import { environment } from 'src/environments/environment';
import { Fee } from '../../models/fee.model';
import { TranslateService } from '@ngx-translate/core';
declare let $: any;
@Component({
  selector: 'app-edit-fund',
  templateUrl: './edit-fund.component.html',
  styleUrls: ['./edit-fund.component.scss'],
  providers: [ValidateService, DataService],
})
export class EditFundComponent extends CreateProduct implements OnInit, OnDestroy {
  closedOrderBookShiftDay: any = [];
  id: number;
  product: Product = new Product();
  RELEASE_TAX = 'RELEASE_TAX';
  BUY_AGAIN = 'BUY_AGAIN';
  DECREASE_RELEASE_TAX = 'DECREASE_RELEASE_TAX';
  DECREASE_BUY_AGAIN = 'DECREASE_BUY_AGAIN';
  isTest: boolean = true;
  subscriptions: Subscription[] = [];
  discountFeeBuy: any[] = [];
  discountFeeBuyInitial: any[] = [];
  discountFeeBuyParams: any = {};
  discountFeeSell: any[] = [];
  discountFeeSellInitial: any[] = [];
  discountFeeSellParams: any = {};
  isApproved: boolean = false;
  initialProduct: any;
  isCalling: boolean = false;
  Constant = Constant;
  uploader: FileUploader;
  constructor(
      public router: Router,
      public route: ActivatedRoute,
      public productService: ProductService,
      public dataService: DataService,
      public masterDataProductService: MasterDataProductService,
      public toastrService: ToastrService,
      public validateService: ValidateService,
      private translate: TranslateService,
      public dateLanguage: LocaleService,
      private eventManager: EventManager,
      public uploaderService: UploaderService,
      public modalService: NzModalService
  ) {
    super(dataService);
    translate.addLangs(['en_US', 'vi_VN']);
    translate.use('vi_VN');
  }
  ngOnInit() {
    const path = this.route.snapshot.routeConfig.path;
    if (path.includes('approve')) {
      this.isApproved = true;
    }
    this.product = new Product();
    this.type = 'CODE_TRADING_FUND';
    this.tab = this.Constant.CODE_TRADING_FUND;
    this.closedOrderBookShiftDay = [];
    for (let i = 1; i < 31; i++) {
      this.closedOrderBookShiftDay.push({
        key: -i,
        text: 'T-' + i
      });
    }
    super.ngOnInit('CODE_TRADING_FUND');
    this.uploader = this.uploaderService.initUploader(
      environment.urlUploadBackEnd + Constant.API_UPLOAD, 'edit-fund-upload');
    this.subscriptions = [
      this.eventManager.subscribe('edit-fund-upload', (res) => {
        this.product.surveyIpoTemplate =  res.content.imagePath;
      }),
      this.eventManager.subscribe(this.RELEASE_TAX + '-result' , (res) => {
        this.product.feeBuys = [...(res.content || [])];
      }),
      this.eventManager.subscribe(this.BUY_AGAIN + '-result' , (res) => {
        this.product.feeSells = [...(res.content || [])];
      }),
      this.eventManager.subscribe(this.DECREASE_RELEASE_TAX + '-result' , (res) => {
        this.discountFeeBuy = (res.content || []);
      }),
      this.eventManager.subscribe(this.DECREASE_BUY_AGAIN + '-result' , (res) => {
        this.discountFeeSell = (res.content || []);
      }),
    ];
  
    this.getMasterData();
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
  }
  getMasterData() {
    forkJoin(
      this.getRelationalOperator(),
      this.getRiskLevel(),
      this.getDayOfWeek(),
      this.getAssets(),
      this.getFundType(),
      this.getFundAssetType(),
    )
    .subscribe((results) => {
        this.complete(results);
    });
  }
  getRelationalOperator() {
    return this.masterDataProductService.getRelationalOperator()
    .pipe(map((res: any) => {
      this.resource.relationalOperators = res.list || [];
      this.resource.relationalOperators.forEach((operator) => {
        switch (operator.name) {
          case '<=':
          operator.reverseOperator = '>=';
          break;
          case '<':
          operator.reverseOperator = '>';
          break;
          case '>=':
          operator.reverseOperator = '<=';
          break;
          case '>':
          operator.reverseOperator = '<';
          break;
        }
      });
      return res;
    }));
  }
  getRiskLevel() {
    return this.masterDataProductService.getRiskLevel()
    .pipe(map((res: any) => {
      this.resource.riskLevels = res.list || [];
      return res;
    }));
  }
  getDayOfWeek() {
    return this.masterDataProductService.getDayOfWeek()
    .pipe(map((res: any) => {
      this.resource.daysOfWeek = res.list || [];
      this.resource.daysOfWeek.unshift({
        id: 0,
        name: 'Hằng ngày'
      })   
      return res;
    }));
  }
  getAssets() {
    return this.masterDataProductService.getAssets()
    .pipe(map((res: any) => {
      this.resource.assetAllocations = res.list || [];
      return res;
    }));
  }
  getFundType() {
    return this.masterDataProductService.getFundType()
    .pipe(map((res: any) => {
      this.resource.fundTypes = res.list || [];
      return res;
    }));
  }
  getFundAssetType() {
    return this.masterDataProductService.getFundAssetType()
    .pipe(map((res: any) => {
      this.resource.fundAssetTypes = res.list || [];
      return res;
    }));
  }
  complete(array) {
    const params = this.route.snapshot.params;
    this.id = params.id;
    if (this.id) {
      this.getDetail();
    }
    this.getDecreaseFeeBuyList();
    this.getDecreaseFeeSellList();
    this.getResource();
  }
  getDetail() {
    this.productService
      .find(this.id)
      .subscribe(
        (res: any) => {
          const product = res.body.data;
          this.product = new Product(product);
          this.product.initProduct(product);
          if (this.product.type.code === 'NEW_FUND') {
            this.changeTab('NEW_FUND')
          }
          if (this.product.productFund) {
            if (this.product.productFund.ipoStartTime) {
              const ipoStartTime =  new Date(this.product.productFund.ipoStartTime);
              this.product.startIPODate = DateUtil.parseDate(ipoStartTime, 'yyyy-MM-dd');
              this.product.startIPOTime = DateUtil.parseDate(ipoStartTime, 'hh:mm');
              this.product.ipoStartTime = this.product.productFund.ipoStartTime;
            }
            if (this.product.productFund.ipoEndTime) {
              const ipoEndTime =  new Date(this.product.productFund.ipoEndTime);
              this.product.endIPODate = DateUtil.parseDate(ipoEndTime, 'yyyy-MM-dd');
              this.product.endIPOTime = DateUtil.parseDate(ipoEndTime, 'hh:mm');
              this.product.ipoEndTime = this.product.productFund.ipoEndTime;
            }
            this.product.surveyIpoTemplate = this.product.productFund.surveyIpoTemplate || '';
            this.product.issueAtDate = this.product.productFund.issueAt ? DateUtil.parseDate(this.product.productFund.issueAt, 'yyyy-MM-dd') : undefined;
            this.product.allocationDuration = this.product.productFund.allocationDuration;
            this.product.isReconcileByTransferAmount = this.product.productFund.isReconcileByTransferAmount;
          }
          const listFee = (product.listFee || {});
          listFee.BUYFeeList = (listFee.BUYFeeList || []).map((item, index) => { 
            item.typeCode = 'BUY';
            item.schemeId = (item.schemeId || {}).id;
            return new Fee(item) ;
          });
          listFee.SELLFeeList = (listFee.SELLFeeList || []).map((item, index) => { 
            item.schemeId = (item.schemeId || {}).id;
            item.typeCode = 'SELL';
            return new Fee(item) ;
          });
          listFee.SELL_PENALTYFeeList = (listFee.SELL_PENALTYFeeList || []).map((item, index) => { 
            item.schemeId = (item.schemeId || {}).id;
            return new Fee(item) ;
          });
          this.product.feeBuys = (listFee.BUYFeeList || []).map((item, index) => {
            return new Fee(item) ;
          });
          this.product.feeSells = (listFee.SELLFeeList || []).map((item, index) => {
            return new Fee(item) ;
          });
          if (this.product.closedBankNote) {
            this.product.closedBankNoteHour = this.product.closedBankNote.substring(0, 2);
            this.product.closedBankNoteMinute = this.product.closedBankNote.substring(3, 5);
          }
          if (this.product.closedOrderBookAt) {
            this.product.closedOrderBookAtHour = this.product.closedOrderBookAt.substring(0, 2);
            this.product.closedOrderBookAtMinute = this.product.closedOrderBookAt.substring(3, 5);
          }
          this.initialProduct = new Product(this.product);
          
        }
      );
  }
  createBody() {
    const product: any = JSON.parse(JSON.stringify(this.product));
    if (this.product.closedOrderBookAt) {
      product.closedOrderBookAt = this.parseTime(this.product.closedOrderBookAt.split(':'));
    }
    if (this.product.closedBankNote) {
      product.closedBankNote = this.parseTime(this.product.closedBankNote.split(':'));
    }
    product.closedOrderBookShiftDay =  product.closedOrderBookShiftDay || - 1;
    product.firstIssueDate = this.startDate;
    product.endIssueDate = this.endDate;
    product.expectedReturn = this.product.expectedReturn;
    product.managementFee = this.product.managementFee;
    product.performanceFee = this.product.performanceFee ? this.product.performanceFee : null;
    product.price = this.product.issuePrice;
    product.issueValue = product.issueValue ? this.product.issueValue : null;
    product.buyMinValue = product.buyMinValue ? this.product.buyMinValue : null;
    product.buyMaxValue = product.buyMaxValue ? this.product.buyMaxValue : null;
    product.sellMin = product.sellMin ? this.product.sellMin : null;
    product.transferSellMin  = product.transferSellMin  ? this.product.transferSellMin  : null;

    product.nav = this.product.nav;
    product.holdingMin = this.product.holdingMin;
    product.lastYearNav = this.product.lastYearNav;
    product.listAssetAllocationId = [];
    product.assetAllocation1Id && product.listAssetAllocationId.push(product.assetAllocation1Id);
    product.assetAllocation2Id && product.listAssetAllocationId.push(product.assetAllocation2Id);
    product.completeTransactionDuration = this.product.completeTransactionDuration;
    product.productTransactionDateList = [];
    this.product.transactionDates.forEach((item) => item && product.productTransactionDateList.push(item.id) );
    product.productSupervisoryBankAccountList = this.product.productSupervisoryBankAccountList.map((item) => {
      item.bankId = item.bankId ? item.bankId.id || item.bankId  : item.id;
      return item;
    });
    product.ipoStartTime = product.ipoStartTime ? product.ipoStartTime : null;
    product.ipoEndTime = product.ipoEndTime ? product.ipoEndTime : null
    product.issueAt = DateUtil.revertDate(`${this.product.issueAtDate},00:00`, `yyyy-MM-dd,hh:mm`).getTime();;
    product.closedBankNote = `${product.closedBankNoteHour}:${product.closedBankNoteMinute || '00'}`;
    product.closedOrderBookAt = `${product.closedOrderBookAtHour}:${product.closedOrderBookAtMinute  || '00'}`;
    return product;
  }
  disabledButton() {
    let result = false;
    if (this.product.feeBuys.some(item => item.fee === undefined || (item.beginValue === 0 && item.endValue === null))
      || this.product.feeSells.some(item => !item.fee === undefined || (item.beginValue === 0 && item.endValue === null))) {
      result = true;
    }
    return result;
  }
  test() {
    this.eventManager.broadcast({ name: this.RELEASE_TAX + '-emit',content: {} });
    this.eventManager.broadcast({ name: this.BUY_AGAIN + '-emit',content: {} });
    this.eventManager.broadcast({ name: this.DECREASE_RELEASE_TAX + '-emit',content: {} });
    this.eventManager.broadcast({ name: this.DECREASE_BUY_AGAIN + '-emit',content: {} });
    this.parsebeforeValidated();
    setTimeout(() => {
      const error = $('.error-text');
      if ((error && error.length > 0) || this.disabledButton()) {
        this.toastrService.error('Có dữ liệu bị lỗi');
        return true;
      }
      const properties = this.checkChange() || [];
      properties.sort((a,b) => {return a.key > b.key ? 1 : -1});
      const modal = this.modalService.create({
        nzTitle: '',
        nzWidth: '650px',
        nzStyle: {top: '20px'},
        nzClassName: 'check-change-popup',
        nzContent: CheckChangeProductPopupComponent,
        nzData: {
          properties: properties,
        },
        nzOnOk: (() => { this.save() })
      });
    }, 1000)
  }
  checkChange() {
    let changeObject = ChangedObject.parse(JSON.parse(JSON.stringify(this.product)), JSON.parse(JSON.stringify(this.initialProduct)));
    delete changeObject.listFee;
    delete changeObject.productTransactionDateList;
    delete changeObject.productSupervisoryBankAccountList;
    const properties = Object.keys(changeObject).map((key) => {
      let initValue = this.initialProduct[key];
      let changeValue = changeObject[key];
      switch (key) {
        case 'feeBuys':
          initValue = 'Có thay đổi';
          changeValue = 'Có thay đổi';
          break;
        case 'feeSells':
          initValue = 'Có thay đổi';
          changeValue = 'Có thay đổi';
          break;
        case 'endIssueAt':
        case 'firstEndIssueAt':
        case 'maturityDate':
          initValue = DateUtil.parseDate(initValue, 'dd/MM/yyyy');
          changeValue = DateUtil.parseDate(changeValue, 'dd/MM/yyyy');;
          break;
        case 'ipoStartTime':
        case 'ipoEndTime':
          initValue = DateUtil.parseDate(initValue, 'dd/MM/yyyy, hh:mm');
          changeValue = DateUtil.parseDate(changeValue, 'dd/MM/yyyy, hh:mm');
          break;
        case 'riskLevelId':
          initValue = (this.resource.riskLevels.find(item => item.id === initValue) || {}).name;
          changeValue = (this.resource.riskLevels.find(item => item.id === changeValue) || {}).name;
          break;
        case 'assetAllocation1Id':
          initValue = (this.resource.assetAllocations.find(item => item.id === initValue) || {}).name;
          changeValue = (this.resource.assetAllocations.find(item => item.id === changeValue) || {}).name;
          break;
        case 'assetAllocation2Id':
          initValue = (this.resource.assetAllocations.find(item => item.id === initValue) || {}).name;
          changeValue = (this.resource.assetAllocations.find(item => item.id === changeValue) || {}).name;
          break;
        case 'closedOrderBookShiftDay':
          initValue = (this.closedOrderBookShiftDay.find(item => item.key == initValue) || {}).text;;
          changeValue = (this.closedOrderBookShiftDay.find(item => item.key == changeValue) || {}).text;;
          break;
        case 'fundTypeId':
          initValue = (this.resource.fundTypes.find(item => item.id === initValue) || {}).name;;
          changeValue = (this.resource.fundTypes.find(item => item.id === changeValue) || {}).name;;
          break;
        case 'fundAssetTypeId':
            initValue = (this.resource.fundAssetTypes.find(item => item.id === initValue) || {}).name;;
            changeValue = (this.resource.fundAssetTypes.find(item => item.id === changeValue) || {}).name;;
            break;
        case 'transactionDates':
          initValue = this.initialProduct.transactionDates.map(item => item ? item.name : '').join(', ');
          initValue = initValue.replace(/ ,/g, '');
          changeValue = this.product.transactionDates.map(item => item ? item.name : '').join(', ');
          changeValue = changeValue.replace(/ ,/g, '');
          break;
        case '':
          initValue = null;
          changeValue = null;
          break;
      }
      return {
        key,
        initValue,
        changeValue
      }
    });
    changeObject = ChangedObject.parse(Object.assign([], this.discountFeeBuy), this.discountFeeBuyInitial);
    changeObject = ChangedObject.parse(Object.assign([], this.discountFeeSell), this.discountFeeSellInitial);
    return properties;
  }
  save() {
    if (!this.validate()) {
      return;
    }
    this.isTest = false;
    this.product.listFee = [...this.product.feeBuys, ...this.product.feeSells];
    this.executeRequest();
  }
  approve() {
    this.isValidated = true;
    setTimeout(() => {
      if (!this.hasError()) {
        const body = {
          vsdFeeId: this.product.vsdFeeId,
          hsbcCode: this.product.hsbcCode
        }
        this.productService.approve(this.id, body)
        .subscribe(
          (res: any) => {
            this.toastrService.success('Approve Product Successfully!');
            this.router.navigate(['/products/fund']);
          },
          (error) => {
            const text = error && error.error ? error.error.message: '';
            this.toastrService.error(text || 'Error Upload');
          }
        )
      }
    }, 100)
  }
  hasError() {
    const error = $('.error-text');
    if (error && error.length > 0) {
      return true;
    } else return false;
  }
  changeTab(tab) {
    this.tab = tab;
  }
  checkExist(id) {
    return this.product.agents.some(agent => agent.id === id);
  }
  changeTime(event) {
    // const moreHouse = event.substring(6, 10) === 'AM' ? 0 : 12;
    // let hour: any = moreHouse ? parseInt(event.substring(0, 2)) + moreHouse : event.substring(0, 2);
    // const result = hour +  event.substring(2, 5);
    // return result;

    return event;
  }
  executeRequest() {
    this.isCalling = true;
    forkJoin(
      this.saveDecreaseFeeBuyList(),
      this.saveDecreaseFeeSellList(),
      this.callUpdate(),
    )
    .subscribe((results) => {
      this.isCalling = false;
      this.completeUpdate(results);
    });
  }
  completeUpdate(array) {
    this.toastrService.success('Save Product Successfully!');
  }
  callUpdate() {
    const product: any = this.createBody();
    delete product.maturityAt;
    delete product.maturityDate;
    const body = JSON.parse(JSON.stringify(product));
    delete body.feeBuys;
    delete body.feeSells;
    delete body.productFund;
    delete body.productInfo;
    delete body.transactionDates;
    delete body.productSupervisoryBankAccountList;
    delete body.fees;
    return this.productService.update(body)
    .pipe(map((res: any) => {
      return res;
    }));
  }
  getDecreaseFeeBuyList() {
    const body = {
      productId: this.id,
      type: 'BUY',
      page: 1,
      size: 100
    };
    this.productService.getDecreaseFeeList(body)
    .subscribe((res: any) => {
      this.discountFeeBuy = res.body ? res.body.data.list : [];
      this.discountFeeBuy = this.discountFeeBuy.map((item, index) => {
        item.typeCode =  'DISCOUNT-BUY';
        if (index === this.product.feeSells.length - 1){ 
          item.endValue = null;
        }
        return new Fee(item) ;
      })
      this.discountFeeBuyInitial = JSON.parse(JSON.stringify(this.discountFeeBuy));
    })
  }
  saveDecreaseFeeBuyList() {
    const body = {
      productId: this.id,
      type: 'BUY',
      page: 1,
      size: 100,
      productFeeDiscountInDtoList: this.discountFeeBuy
    };
    return this.productService.saveDecreaseFeeList(body)
    .pipe(map((res: any) => {
      return res;
    }));
  }
  getDecreaseFeeSellList() {
    const body = {
      productId: this.id,
      type: 'SELL',
      page: 1,
      size: 100,
    };
    this.productService.getDecreaseFeeList(body)
    .subscribe((res: any) => {
      this.discountFeeSell = res.body ? res.body.data.list : [];
      this.discountFeeSellInitial = JSON.parse(JSON.stringify(this.discountFeeSell));
    })
  }
  saveDecreaseFeeSellList() {
    const body = {
      productId: this.id,
      type: 'SELL',
      page: 1,
      size: 100,
      productFeeDiscountInDtoList: this.discountFeeSell
    };
    return this.productService.saveDecreaseFeeList(body)
    .pipe(map((res: any) => {
      return res;
    }));
  }
  changeTransactionDate() {
    const day = this.product.transactionDates.find((item) => item.id == this.selectedDay);
    if (day) {
      return;
    } else {
      const date = this.resource.daysOfWeek.find((item) => item.id == this.selectedDay);
      if (date) {
        this.product.transactionDates.push(date);
      }
    }
    const everyday = this.product.transactionDates.find((item) => item.id == "0");
    if (everyday) {
      this.product.transactionDates = this.resource.daysOfWeek.slice(1);
    }
    this.product.transactionDates.sort((a, b) => { a.id - b.id});
  }
  removeDay(index) {
    this.product.transactionDates.splice(index, 1);
  }
  
  validateDateSmallerField(date) {
    const defaultDate: any = new Date();
    if (!this[date]) {
      return false;
    }
    const value = new Date(this[date]);
    if (date === 'startDate') {
      return value.getTime()  +  23 * 60 * 60 * 1000 >= defaultDate.getTime();
    } else if (date === 'endDate') {
      return value.getTime()  +  23 * 60 * 60 * 1000 < defaultDate.getTime();
    } 
  }
  
  validateNumberField(number) {
    let value = number;
    if (value === 0) {
      value = 0.01;
    }
    return (!value && this.isValidated) || (value && parseInt(value) < 0);
  }
}
